export default {
    'Menu': 'Menü'
};
